// extracted by mini-css-extract-plugin
export var container = "_cs-0";
export var containerTopRight = "_cs-1";